"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Fullscreen32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M10.854 21.146a.5.5 0 010 .708L5.706 27H9.5a.5.5 0 110 1H4.48a.503.503 0 01-.052-.005L4.5 28a.502.502 0 01-.354-.146l-.011-.013a.503.503 0 01-.033-.039l.044.052A.502.502 0 014 27.5v-5a.5.5 0 111 0v3.792l5.146-5.146a.5.5 0 01.708 0zM9.5 4a.5.5 0 010 1H5.707l5.147 5.146a.5.5 0 01.057.638l-.057.07a.5.5 0 01-.708 0L5 5.707V9.5a.5.5 0 01-.41.492L4.5 10a.5.5 0 01-.5-.5v-5a.51.51 0 01.077-.267c.02-.03.043-.06.07-.087l-.045.052a.503.503 0 01.033-.04l.011-.012a.51.51 0 01.249-.135A.498.498 0 014.5 4l-.074.005A.503.503 0 014.49 4H4.5zm18 0h.012c.02 0 .041.002.062.005L27.5 4a.502.502 0 01.354.146l.011.013a.503.503 0 01.033.039l-.044-.052A.502.502 0 0128 4.5v5a.5.5 0 11-1 0V5.706l-5.146 5.148a.5.5 0 01-.708-.708L26.292 5H22.5a.5.5 0 110-1h5zm-6.354 17.146a.5.5 0 01.708 0L27 26.293V22.5a.5.5 0 01.41-.492L27.5 22a.5.5 0 01.5.5v5a.509.509 0 01-.077.267.498.498 0 01-.07.087l.045-.052a.503.503 0 01-.033.04l-.011.012a.51.51 0 01-.249.135.498.498 0 01-.105.011l.072-.005a.503.503 0 01-.051.005H22.5a.5.5 0 110-1h3.793l-5.147-5.146a.5.5 0 01-.057-.638z", className: "fullscreen-32_svg__path-1" }))); };
var StyledFullscreen32 = styled_components_1.default(Fullscreen32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledFullscreen32;
var templateObject_1;
//# sourceMappingURL=Fullscreen32.js.map